// extracted by mini-css-extract-plugin
export var container = "_hd-0";
export var segment = "_hd-2";
export var segmentActive = "_hd-3";
export var track = "_hd-1";